<main>
    <div class="d-flex flex-row justify-content-center admin-page-header">
        <h1 class="admin-page-title">
            Resources
        </h1>
    </div>

    <div class="mediumContainer">
        @if (loading || (!loading && resources.length == 0 && helpfulLinks.length == 0)) {
            <div aria-live="polite" class="w-100 d-flex flex-col align-items-center"
                 role="status">
                @if (loading) {
                    <mat-spinner aria-label="Loading resources" color="primary"></mat-spinner>
                }
                @if (!loading && resources.length == 0 && helpfulLinks.length == 0) {
                    <div class="illustrated-empty-state">
                        <img src="assets/images/reading-character.png" width="431" height="422"
                             alt="Yellow character reading a book">
                        @if (loadFailed) {
                            <h2>We couldn't load the resources</h2>
                            <p>Please refresh the page to try again.</p>
                        } @else {
                            <h2>Nothing here just yet</h2>
                            <p>No resources are available right now. Please check back later.</p>
                        }
                    </div>
                }
            </div>
        }
        <div class="memoriesContainer">
            @if (helpfulLinks.length > 0) {
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="mb-10">Helpful Links</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <mat-divider></mat-divider>
                        <mat-list>
                            @for (resource of helpfulLinks; track resource) {
                                <button (click)="link(resource.link, false)" class="clickable" mat-list-item
                                        type="button">
                                    <mat-icon matListItemIcon>link</mat-icon>
                                    <div matListItemTitle>{{ resource.title }}</div>
                                </button>
                            }
                        </mat-list>
                    </mat-card-content>
                </mat-card>
            }
            @for (resource of resources; track resource) {
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="mb-10">{{ resource.name }}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <mat-divider></mat-divider>
                        <mat-list>
                            @for (item of resource.items; track item) {
                                <button (click)="link(item.content, item.download, item.title)" class="clickable"
                                        mat-list-item
                                        type="button">
                                    @if (item.download) {
                                        <mat-icon matListItemIcon>get_app</mat-icon>
                                    }
                                    @if (!item.download) {
                                        <mat-icon matListItemIcon>link</mat-icon>
                                    }
                                    <div matListItemTitle>{{ item.title }}</div>
                                </button>
                            }
                        </mat-list>
                    </mat-card-content>
                </mat-card>
            }
        </div>

    </div>
</main>
